import { useRequestContext } from '@coolblue-development/next-request-context/client';
import { useMemo, useState } from 'react';
import { useForm } from 'react-hook-form';
import { submitThumbInputFeedback } from '../../server/actions.js';
export const useFeedbackForm = ({ labels, referrer }) => {
    const { csrfToken } = useRequestContext();
    const [isHelpful, setIsHelpful] = useState(true);
    const [hasSubmitFired, setHasSubmitFired] = useState(false);
    const [hasSubmitted, setHasSubmitted] = useState(false);
    const [isSuccessfulSubmit, setIsSuccessfulSubmit] = useState(false);
    const [interacted, setInteracted] = useState(false);
    const { handleSubmit, register } = useForm();
    const isSubmitting = useMemo(() => hasSubmitFired && !hasSubmitted, [hasSubmitFired, hasSubmitted]);
    const onSubmit = async ({ comment }) => {
        setHasSubmitFired(true);
        const result = await submitThumbInputFeedback(isHelpful, referrer, labels, comment, csrfToken);
        setHasSubmitted(true);
        setIsSuccessfulSubmit(result.success);
    };
    const onHelpfulClick = () => {
        setIsHelpful(true);
        setInteracted(true);
    };
    const onUnhelpfulClick = () => {
        setIsHelpful(false);
        setInteracted(true);
    };
    return {
        isHelpful,
        hasSubmitted,
        hasSubmitFired,
        isSuccessfulSubmit,
        interacted,
        isSubmitting,
        register,
        handleSubmit: handleSubmit(onSubmit),
        onHelpfulClick,
        onUnhelpfulClick,
    };
};
//# sourceMappingURL=useFeedbackForm.js.map